import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { Input } from "formsy-react-components";
import "react-toggle/style.css";

// import CustomToggle from "../user-account/Toggle"; // uses formsy stuff ugh
import Toggle from "react-toggle";
import { IoStarOutline, IoStar } from "react-icons/io5";

import * as codeActions from "../../actions/codeActions";

const ProjectFavoritesSelect = ({
  value,
  // isMulti = false,
  onChange,
  disabled
  // handleToggle,
  // favorites,
  // codes = [],
  // actions
}) => (
  // console.log("value",value);
  <div
    style={{
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      gap: "1.5rem"
    }}
  >
    <label
      htmlFor="toggle"
      style={{
        fontSize: "14px",
        marginTop: "0.5rem"
      }}
    >
      Favorites Only
    </label>
    <Toggle
      id="toggle"
      defaultChecked={false}
      onChange={(e) => onChange(e)}
      value={value ? "checked" : "unchecked"}
      checked={value}
      disabled={disabled}
      icons={{
        checked: <IoStar />,
        unchecked: <IoStarOutline />
      }}
    />
  </div>
);

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectFavoritesSelect);

ProjectFavoritesSelect.propTypes = {
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  // codes: PropTypes.array,
  // actions: PropTypes.object,
  // auth: PropTypes.object,
  // isMulti: PropTypes.bool,
  value: PropTypes.bool
  // handleToggle: PropTypes.func,
  // favorites: PropTypes.array
};
